import Vue from 'vue'
import VueRouter from 'vue-router'
import HangView from '@/views/HangView.vue'
import SuccesView from '@/views/SuccesView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HangView
  },
  {
    path: '/success',
    component: SuccesView
  },
]

const router = new VueRouter({
  routes: routes,
  mode: "history"
})

export default router
